<template>
    <BreadCrumb PageTitle="Modifier un organe" />
    <EditOrgane />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumb from "../../components/Common/BreadCrumb.vue"
import EditOrgane from "@/components/Organes/EditOrgane.vue";

export default defineComponent({
    name: "EditOrganePage",
    components: {
        BreadCrumb,
        EditOrgane,
    },
});
</script>